import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPushpinFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.459 7.004a1.975 1.975 0 0 0 1.215-1.826v-.825a1.98 1.98 0 0 0-1.979-1.979h-7.39a1.98 1.98 0 0 0-1.979 1.979v.825c0 .8.477 1.517 1.249 1.841a.98.98 0 0 1 .601.902v1.863a1 1 0 0 1-.112.454l-1.513 2.895a1.982 1.982 0 0 0 1.754 2.895h2.945v4.848a.75.75 0 0 0 1.5 0v-4.848h2.945a1.98 1.98 0 0 0 1.754-2.895l-1.514-2.897a.96.96 0 0 1-.112-.452V7.921c0-.396.237-.75.636-.917"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPushpinFilled);
export default ForwardRef;
